import { render, staticRenderFns } from "./gunlukturlistesi.vue?vue&type=template&id=8b5551d0&scoped=true&"
import script from "./gunlukturlistesi.vue?vue&type=script&lang=js&"
export * from "./gunlukturlistesi.vue?vue&type=script&lang=js&"
import style0 from "./gunlukturlistesi.vue?vue&type=style&index=0&id=8b5551d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5551d0",
  null
  
)

export default component.exports